/*
 * @Author: Jin Biao
 * @Date: 2019-03-25 11:08:44
 * @Title: 此uniCloud 云函数请求
 * @Description: uniCloud专用
 */

/* eslint-disable */
// uni cloud请求
import axiosCloud from "axios";
import config from "./config";
import { Loading, Message } from "element-ui";

// 超时时间
axiosCloud.defaults.timeout = 100000;

// http请求拦截器 打开Loading
axiosCloud.interceptors.request.use(
  config => {
    // element ui Loading方法
    this.loadingInstance = Loading.service();
    return config;
  },
  error => {
    this.loadingInstance.close();
    Message.error({
      message: "加载超时~"
    });

    return Promise.reject(error);
  }
);

// http响应拦截器 关闭Loading
axiosCloud.interceptors.response.use(
  data => {
    // 响应成功关闭loading
    this.loadingInstance.close();
    return data;
  },
  error => {
    this.loadingInstance.close();
    return Promise.reject(error);
  }
);

// 添加请求拦截器  更新最新用户 KEY
axiosCloud.interceptors.request.use(
  function(config) {
    // 在发送请求之前做些什么    // 获取KEY
    config.headers.uid = localStorage.getItem("pbw_user_pc_uid");
    config.headers.token = localStorage.getItem("pbw_user_pc_token");
    return config;
  },
  function(error) {
    // 对请求错误做些什么
    return Promise.reject(error);
  }
);

// 添加请求拦截器  判断是否需要登录权限 以及是否登录
axiosCloud.interceptors.response.use(function(response) {
  if (response.data.code == 333) {
    localStorage.removeItem("pbw_user_pc_uid");
    localStorage.removeItem("pbw_user_pc_token");
    setTimeout(function() {
      window.location.href = "/login?type=lose";
    }, 500);
  }
  // 正常请求即可每10分钟进行检测【正常使用则一直加一小时】
  return response;
});

/*普通接口模块*/
axiosCloud.defaults.baseURL =
  process.nextTick.NODE_ENV === "development"
    ? "/api"
    : "https://177736ef9-f8ab-45ae-a334-cef3c6f36701.bspapp.com/http/";
axiosCloud.defaults.headers.post["Content-Type"] = "multipart/form-data";

const GET = (url, data) => {
  return axiosCloud.get(url, { params: data }).then(res => res.data);
};
const POST = (url, data) => {
  return axiosCloud.post(url, data).then(res => res.data);
};

export default {
  GET,
  POST
};



// WEBPACK FOOTER //
// ./src/api/api.js